import { TypeOfUser } from '../helpers/Constants';
import { AnalyticsUserRole } from '../models/AnalyticsModel';

const USER_ROLES: Partial<Record<TypeOfUser, AnalyticsUserRole>> = {
  [TypeOfUser.pharmacy]: AnalyticsUserRole.pharmacy,
  [TypeOfUser.pharmacyAdmin]: AnalyticsUserRole.pharmacyAdmin,
  [TypeOfUser.admin]: AnalyticsUserRole.admin,
  [TypeOfUser.superAdmin]: AnalyticsUserRole.admin,
};

// PHARMACISTS, TECHNICIANS AND STUDENTS ARE ALL PROFESSIONALS
export const getAnalyticsUserRole = (userType: TypeOfUser): AnalyticsUserRole =>
  USER_ROLES[userType] ?? AnalyticsUserRole.professional;
